import { render } from "./App.vue?vue&type=template&id=6e80c8be"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6e80c8be&lang=scss"

import exportComponent from "/Users/wlxqxxf/铭方营养/nutrition-web-wechat/node_modules/_vue-loader@16.8.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__